module.exports = __webpack_public_path__ + "media/src/images/female_speaker_bg-042a6093506781c52605877c107a879e.jpg";